import { DataField, FieldsetCard } from '@if/mui'
import { useTranslation } from 'react-i18next'
import { CalculatorEstimateResultDto } from '@src/types/CalculatorEstimateDto'

interface LenderFeeDisplayProps {
  calculatedRate?: CalculatorEstimateResultDto | null
}

/**
 * The fee rate charged to the customer (`lenderFeeRate`), shown *only* when it is 0 —
 * a waived lender fee is the notable case worth stating. Any other rate is standard
 * and the section is hidden entirely.
 *
 * Note this is the inverse of BusinessFeeDisplay, which hides at 0 and shows
 * otherwise. No switch here: there is nothing to reveal beyond the fact it is 0.
 */
export const LenderFeeDisplay = ({ calculatedRate }: LenderFeeDisplayProps) => {
  const { t } = useTranslation()

  if (calculatedRate?.lenderFeeRate !== 0) return null

  return (
    <FieldsetCard title={t('calculator.lenderFeeTitle')} subtitle={t('calculator.lenderFeeDescription')}>
      <DataField label={t('calculator.feeRateLabel')} value={`${calculatedRate.lenderFeeRate} %`} />
    </FieldsetCard>
  )
}
